import { animate, animation, style, transition, trigger, useAnimation } from '@angular/animations';
import { backInLeft, backInRight, backOutLeft, backOutRight, fadeIn, fadeOut } from 'ng-animate';

const fadeInHeight = animation([
  style({ opacity: 0, height: 0 }),
  animate('500ms ease-out', style({ opacity: 1, height: '*' })),
]);

export const fadeInEnterHeight = trigger('fadeInEnterHeight', [
  transition(':enter', useAnimation(fadeInHeight)),
]);

export const fadeInEnter = trigger('fadeInEnter', [transition(':enter', useAnimation(fadeIn))]);

export const fadeIn2XFastEnter = trigger('fadeIn2XFastEnter', [
  transition(':enter', useAnimation(fadeIn, { params: { timing: 0.5, delay: 0 } })),
]);

export const fadeOutLeave = trigger('fadeOutLeave', [transition(':leave', useAnimation(fadeOut))]);

export const fadeOut2XFastLeave = trigger('fadeOut2XFastLeave', [
  transition(
    ':leave',
    useAnimation(fadeOut, {
      params: { timing: 0.5, delay: 0 },
    }),
  ),
]);

export const backInRightEnter = trigger('backInRightEnter', [
  transition(':enter', useAnimation(backInRight)),
]);
export const backOutRightLeave = trigger('backOutRightLeave', [
  transition(':leave', useAnimation(backOutRight)),
]);

export const backInLeftEnter = trigger('backInLeftEnter', [
  transition(':enter', useAnimation(backInLeft)),
]);
export const backOutLeftLeave = trigger('backOutLeftLeave', [
  transition(':leave', useAnimation(backOutLeft)),
]);
